import React, { useCallback } from 'react';
import {
  Form,
  required,
  useRecordContext,
  useRefresh,
  useStore,
  useUpdate,
} from 'react-admin';
import { FieldValues } from 'react-hook-form';

import {
  Box,
  Button,
} from '@mui/material';
import { Cancel } from '@mui/icons-material';
import Save from '@mui/icons-material/Save';
import CommentInput from '../../../comment/CommentInput';
import { ICaseAnalysis } from '../../../../utilities/schemas/caseAnalysis';
import agentModes, { AgentMode } from '../../../../constants/agentModes';
import { aiRichTextFieldSx } from './AiAnalysisResult';

const AiAnalysisEditResult = () => {
  const analysisData = useRecordContext<ICaseAnalysis>();

  const [update] = useUpdate();
  const refresh = useRefresh();
  const [, setAgentMode] = useStore<AgentMode>('agentMode', agentModes.FETCHING);

  const handleEditSubmit = useCallback((data: FieldValues) => {
    if (!analysisData) return;
    update(
      `cases/${analysisData.caseId}/analysis`,
      {
        id: `${analysisData.id}/revise`,
        data,
      },
      {
        onSuccess: () => {
          setAgentMode(agentModes.VIEW);
          refresh();
        },
      },
    );
  }, [analysisData, update, setAgentMode, refresh]);

  if (!analysisData) return null;

  return (
    <Box
      sx={{
        flexGrow: 1,
        overflow: 'auto',
        '& > form': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Form
        record={{
          message: analysisData.result.userRevisions.length > 0
            ? analysisData.result
              .userRevisions[analysisData.result.userRevisions.length - 1].message
            : analysisData.result.original,
        }}
        onSubmit={handleEditSubmit}

      >
        <CommentInput
          source="message"
          helperText={false}
          validate={required()}
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            '& .RaRichTextInput-editorContent .ProseMirror': {
              padding: 4,
            },
            ...aiRichTextFieldSx,
          }}
        />
        <Box
          display="flex"
          gap={2}
          alignItems="center"
          marginTop={4}
        >
          <Button
            variant="contained"
            type="submit"
            startIcon={<Save />}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            startIcon={<Cancel />}
            onClick={() => setAgentMode(agentModes.VIEW)}
          >
            Cancel
          </Button>
        </Box>
      </Form>
    </Box>
  );
};

export default AiAnalysisEditResult;
